/**
 * useLatestFix — the viewfinder's view of `shotGeo.latestFix()`: the ONE fix the next chunk header
 * is built from. Re-renders when `rememberFix` runs (the visit-level row, a shot-start snapshot; in
 * M3 the continuous `watchPosition`). Nothing here reads the Geolocation API itself.
 */

import { useSyncExternalStore } from 'react';
import { type GeoFix, latestFix, subscribeFix } from './shotGeo';

export function useLatestFix(): GeoFix | null {
  return useSyncExternalStore(subscribeFix, latestFix, latestFix);
}
